export function delay<T extends any>(time = 0, data?: T) {
    return new Promise(resolve => {
        if (!time) resolve(data);
        setTimeout(() => resolve(data), time);
    });
}
